import { faEdit, faPlus, faTrash, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import ReactTable from "react-table";
import { createUpdateSpecialCustomer, deleteSpecialCustomer } from "../../api/IrsClient";
import { ERROR_PREFIX_REGEX } from "../../constant";
import BulkUploadModal from "./BulkUploadModal";
import SpecialCustomerModal from "./SpecialCustomerModal";

function SpecialCustomerTable({
  specialCustomerPageable,
  onRefreshSpecialCustomerUpdate,
  onPageRequestChange,
  isLoading,
  setInfoModal,
  setErrorModal,
}) {

  const [pageable, setPageable] = useState({ page: 0, numberOfPage: 1, pageSize: 10 });
  const [isShowEditCustomerModal, setIsShowEditCustomerModal] = useState(false);
  const [isShowNewCustomerModal, setIsShowNewCustomerModal] = useState(false);
  const [isShowBulkUploadModal, setIsShowBulkUploadModal] = useState(false);
  const [selectedSpecialCustomer, setSelectedExchangeRate] = useState(null);
  const [isModalLoading, setIsModalLoading] = useState(false);

  useEffect(() => {
    // calculate page info
    if (specialCustomerPageable) {
      setPageable({
        page: specialCustomerPageable.page - 1,
        pageSize: specialCustomerPageable.total_per_page,
        numberOfPage: Math.ceil(specialCustomerPageable.total / specialCustomerPageable.total_per_page)
      });
    }
  }, [specialCustomerPageable])

  function editSpecialCustomer(data) {
    setSelectedExchangeRate(data);
    setIsShowEditCustomerModal(true);
  }

  async function callApiCreateUpdateSpecialCustomer(request) {
    const operation = request.is_update ? "update" : "addition";
    setIsModalLoading(true);
    try {
      const { data: { status } } = await createUpdateSpecialCustomer(request);
      if (status.code === "0") {
        setIsShowNewCustomerModal(false);
        setIsShowEditCustomerModal(false);
        setInfoModal({
          title: `Mobile number ${operation} successfully.`,
          textCancel: "Ok",
          onCancel: () => setInfoModal(null)
        });
        onRefreshSpecialCustomerUpdate();
      } else {
        setErrorModal({
          title: `Mobile number ${operation} failed!`,
          description: status.message.replace(ERROR_PREFIX_REGEX, "")
        });
      }
    } catch (error) {
      setErrorModal({
        title: `Mobile number ${operation} failed!`,
        description: error.response?.data?.status.message.replace(ERROR_PREFIX_REGEX, "")
      });
    } finally {
      setIsModalLoading(false);
    }
  }

  async function callApiDeleteSpecialCustomer(request) {
    try {
      const { data: { status } } = await deleteSpecialCustomer(request);
      if (status.code === "0") {
        setInfoModal({
          title: "Delete the mobile number successfully.",
        })
        onRefreshSpecialCustomerUpdate();
      }
    } catch (error) {
      setErrorModal({
        title: `Mobile number deletion failed!`,
        description: error.response?.data?.status.message.replace(ERROR_PREFIX_REGEX, "")
      });
    }
  }

  // add special customer
  async function handleOnOkAddCustomer(formValue) {
    const request = {
      is_update: false,
      mobile_number: formValue.mobile_number,
      myanmar_special_rate_id: formValue.myanmar_special_rate,
      cambodia_special_rate_id: formValue.cambodia_special_rate
    }
    await callApiCreateUpdateSpecialCustomer(request);
  }

  // update special customer
  async function handleOnOkUpdateCustomer(formValue) {
    const request = {
      is_update: true,
      mobile_number: formValue.mobile_number,
      myanmar_special_rate_id: formValue.myanmar_special_rate,
      cambodia_special_rate_id: formValue.cambodia_special_rate
    }
    await callApiCreateUpdateSpecialCustomer(request);
  }

  // delete special customer
  async function handleOnDeleteCustomer(mobileNumber) {
    setInfoModal({
      title: `Do you want to delete mobile "${mobileNumber}"?`,
      isOpen: true,
      onOk: async () => {
        const request = { mobile_number: mobileNumber };
        await callApiDeleteSpecialCustomer(request);
        setInfoModal(null)
      },
      onCancel: () => setInfoModal(null)
    });
  }

  function handleOnPageChange(page) {
    onPageRequestChange(page + 1, pageable.pageSize)
  }

  function handleOnPageSizeChange(pageSize) {
    onPageRequestChange(pageable.page + 1, pageSize);
  }

  function showRateIsEnable(item) {
    if (item.enable === true) {
      return <span className="badge badge-success p-2">{item.label}</span>
    } else {
      return <span className="badge badge-secondary p-2">{item.label}</span>
    }
  }

  function prepareColumns() {
    return [
      {
        Header: "Action",
        accessor: "",
        Cell: (props) => {
          return (
            <div>
              <button
                className="btn btn-icon btn-warning"
                data-testid={`edit-${props.original.mobile_number}`}
                onClick={() => editSpecialCustomer(props.original)}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                className="btn btn-icon btn-secondary ml-1"
                data-testid={`delete-${props.original.mobile_number}`}
                onClick={() => handleOnDeleteCustomer(props.original.mobile_number)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>

          );
        }
      },
      {
        Header: "Mobile No.",
        accessor: "mobile_number",
      },
      {
        Header: "Cambodia / KHR",
        accessor: "cambodia_special_rate",
        Cell: ({ value }) => value ? showRateIsEnable(value) : "-"
      },
      {
        Header: "Myanmar / MMK",
        accessor: "myanmar_special_rate",
        Cell: ({ value }) => value ? showRateIsEnable(value) : "-"

      },
      {
        Header: "Last Update",
        accessor: "updated_date",
        Cell: ({ value }) => moment(value).format("DD-MM-YYYY / HH:mm:ss"),
      },
      {
        Header: "Last Update By",
        accessor: "updated_by",
      },
    ];
  }


  return (

    <div className="card card-secondary mt-2">
      <div className="card-header">
        <h5>Special Customer</h5>
      </div>

      {/* Add data button */}
      <div className="col mt-3 d-flex justify-content-end">
        <button
          data-testid="bulk-upload-button"
          className="btn btn-icon btn-success mx-2"
          onClick={() => setIsShowBulkUploadModal(true)}
        >
          <FontAwesomeIcon icon={faUpload} /> Bulk Upload
        </button>
        <button
          data-testid="add-special-customer-button"
          className="btn btn-icon btn-warning"
          onClick={() => setIsShowNewCustomerModal(true)}
        >
          <FontAwesomeIcon icon={faPlus} /> Add
        </button>
      </div>

      {/* Table */}
      <div className="p-3">
        <ReactTable
          data={specialCustomerPageable.special_customers}
          loading={isLoading}
          showPaginationTop={true}
          columns={prepareColumns()}
          manual
          pageSizeOptions={[10, 25, 50, 100]}
          page={pageable.page}
          pages={pageable.numberOfPage}
          pageSize={pageable.pageSize}
          onPageChange={handleOnPageChange}
          onPageSizeChange={handleOnPageSizeChange}
          className="-highlight report"
          resizable={true}
          sortable={false}
          minRows="10"
        />
        <div className="text-left p-2">
          <span className="badge badge-success p-2">Green</span>
          <span className="p-2">Special rate is active</span>
          <span className="badge badge-secondary p-2">Gray</span>
          <span className="p-2">Special rate is inactive or disable</span>
        </div>
      </div>

      {/* Modal */}
      <SpecialCustomerModal
        header="Edit Special Customer"
        data={selectedSpecialCustomer}
        loading={isModalLoading}
        isOpen={isShowEditCustomerModal}
        onOk={handleOnOkUpdateCustomer}
        onCancel={() => {
          setIsShowEditCustomerModal(false);
        }}
        width={600}
      />
      <SpecialCustomerModal
        header="Add Special Customer"
        loading={isModalLoading}
        isOpen={isShowNewCustomerModal}
        onOk={handleOnOkAddCustomer}
        onCancel={() => setIsShowNewCustomerModal(false)}
        width={600}
      />
      <BulkUploadModal
        isOpen={isShowBulkUploadModal}
        onOk={() => setIsShowBulkUploadModal(false)}
        onCancel={() => setIsShowBulkUploadModal(false)}
        setInfoModal={setInfoModal}
        setErrorModal={setErrorModal}
      />
    </div>
  );
}

export default withTranslation()(SpecialCustomerTable);